// extracted by mini-css-extract-plugin
export var closeButton = "_4-1";
export var container = "_4-0";
export var fullModalImage = "_4-2";